var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['proa-card', { material: !_vm.flat, 'no-padding': _vm.noPadding }]},[(_vm.$slots.header)?_c('div',{class:['proa-card-header', { 'border-none': _vm.noHeaderBorder }]},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }